###
# modificationAction    (string)         can be "UPDATE" or "CREATE" (filterConstants):
#                                          used to show correct parts in corresponding HTML
#                                          and call create or update requests
# editedFilterSet       (object/null)    FilterSet object for editing or null
# structure             (object)         StructureCache.getStructure() responce
# filterSets            (object)         FilterSets.get(clientId) responce
# readyToSave           (boolean)        activate/deactivate of "Create"/"Save Changes"
#                                          buttons in parent directive
###
angular.module('rjmNg.directives').directive "filterSetEditor", [
  () ->
    restrict: "E"
    templateUrl: "directive.filterSetEditor.html"
    replace: false
    controllerAs: 'view'
    scope: {
      modificationAction: '=?'
      editedFilterSet: '=?'
      structure: '='
      filterSets: '='
      readyToSave: '='
      openFilterSetsListPage: '='
      modifyFilterSet: '='
      confirmButtonText: '='
    }
    bindToController: true
    controller: [
      "$routeParams"
      "$scope"
      "FilterSets"
      "notification"
      "errorConstants"
      "operatorEnums"
      "filterConstants"
      "logger"
      "changelog"
      (
        $routeParams
        $scope
        FilterSets
        notification
        errorConstants
        operatorEnums
        filterConstants
        logger
        changelog
      ) ->

        view = @
        view.showDependents = false
        view.clientId = $routeParams.clientId
        view.columns = []
        view.filterSetsNames = []
        view.restrictionSetColumns = []
        view.notificationTemplate = 'template.notification.html'
        notificationTimeout = 15

        view.restrictionSet =
          restrictions: []
          sequence:
            string: null
            errorMessage: null

        view.isRestrictionSetValid = false
        view.readyToSave = false

        _updateRestrictionSet = () ->
          if view.editedFilterSet
            view.restrictionSet.sequence.string = view.editedFilterSet.sequence
            for filter in view.editedFilterSet.filters
              restriction =
                left:
                  name: view.structure.columns[filter.left.column_id].name
                  datatype: view.structure.columns[filter.left.column_id].old_data_type
                  column_id: filter.left.column_id
                op: operatorEnums.SCHEMA_SERVICE_COMPARISON_OPERATOR_IDS[filter.operation]
                right: if filter.right.value is null then operatorEnums.NULL else filter.right.value
              view.restrictionSet.restrictions.push(restriction)

        _updateRestrictionSetColumns = () ->
          if view.selectedTable.table is null
            view.restrictionSetColumns = []
          else
            view.restrictionSetColumns = []
            for column in view.columns
              if column.table_id is view.selectedTable.table
                restrictionSetColumn =
                  name: column.name
                  column_id: column.id
                  datatype: column.old_data_type
                view.restrictionSetColumns.push(restrictionSetColumn)

        _isFilterSetNameNotValid = () ->
          if view.newfilterSetName in view.filterSetsNames
            return if view.modificationAction is filterConstants.MODIFICATION_ACTIONS.UPDATE then view.newfilterSetName isnt view.currentFilterSetName else true
          else
            return false

        _showWarning = (text) ->
          notification.warning("warning", text, "filterSetEditor", null, notificationTimeout)

        _showError = () ->
          notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "filterSetEditor", null, notificationTimeout)

        _saveFilterSet = () ->
          data = FilterSets.createDataForRequest(view.selectedTable.table, view.newfilterSetName, view.restrictionSet)

          switch view.modificationAction
            when filterConstants.MODIFICATION_ACTIONS.CREATE
              promise = FilterSets.create(view.clientId, data)
            when filterConstants.MODIFICATION_ACTIONS.UPDATE
              promise = FilterSets.update(view.clientId, view.editedFilterSet.id, data)

          promise.then(
              (response) ->
                switch view.modificationAction
                  when filterConstants.MODIFICATION_ACTIONS.CREATE
                    changelog.save(response.id, 'filter_set', "created")
                    logger.log('Filters Page Usage', 'Save', 1, 'create')
                  when filterConstants.MODIFICATION_ACTIONS.UPDATE
                    changelog.save(response.id, 'filter_set', "changed")
                    logger.log('Filters Page Usage', 'Save', 1, 'edit')
                
                $scope.$emit('filterSetsChanged', view.newfilterSetName)
            ,
              (error) -> _showError()
            )

        _confirmBeforeSaving = () ->
          if confirm("Filter Sets with more than 26 filters will prevent updates from completing when used on calculated columns. Are you sure you want to proceed?")
            _saveFilterSet()

        view.isUpdating = () ->
          return view.modificationAction is filterConstants.MODIFICATION_ACTIONS.UPDATE

        view.isCreating = () ->
          return view.modificationAction is filterConstants.MODIFICATION_ACTIONS.CREATE

        view.checkIfReadyToSave = () ->
          view.readyToSave = view.isRestrictionSetValid and view.newfilterSetName isnt ""

        view.tableChanged = () ->
          _updateRestrictionSetColumns()

        view.loadDependents = () ->
          view.showDependents = true

        $scope.$on 'modifyFilterSet' , (event) ->
          if _isFilterSetNameNotValid()
            _showWarning("A Filter Set with this name already exists. Please try another name.")
          else
            # Batcheetah has an upper limit of 26 filters on filter-sets.
            # warn the user if thats the case, but still let them save it because filter sets
            # can also be used in metrics, and they do not have a limit
            showConfirmationDialog = view.restrictionSet.restrictions.length > 26

            if showConfirmationDialog
              _confirmBeforeSaving()
            else
              _saveFilterSet()

        @$onInit = () ->
          view.columns.push column for id, column of view.structure.columns
          view.filterSetsNames.push filterSet.name for filterSet in view.filterSets
          view.currentFilterSetName = if view.editedFilterSet then view.editedFilterSet.name else ""
          view.newfilterSetName = if view.editedFilterSet then view.editedFilterSet.name else "New Filter Set "
          view.selectedTable =
            table: if view.editedFilterSet then view.editedFilterSet.table_id else null
            column: null

          notification.clear('filterSetEditor')
          _updateRestrictionSet()
          _updateRestrictionSetColumns()

        view
    ]
    link: (scope, element, attributes, view) ->

      scope.$watch 'view.selectedTable.table', view.tableChanged, true
      scope.$watch 'view.isRestrictionSetValid', view.checkIfReadyToSave, true
      scope.$watch 'view.newfilterSetName', view.checkIfReadyToSave, true
      scope.$watch 'view.restrictionSet.restrictions', view.checkIfReadyToSave, true
]
